export var BOTPRESS_ACTIONS = {
  OPEN_CHAT: 'OPEN_CHAT',
  CLOSE_CHAT: 'CLOSE_CHAT',
  TOGGLE: 'TOGGLE',
  SEND_MESSAGE: 'SEND_MESSAGE',
  SEND_EVENT: 'SEND_EVENT',
  NOTIFY: 'NOTIFY'
};
export var BOTPRESS_INTERVAL_DELAY = 500;
export var CONTAINER_VISIBILITY_VISIBLE = 'visible';
export var CONTAINER_VISIBILITY_HIDDEN = 'hidden';
export var ToastTransitionSlide = 'Slide';
export var ToastTransitionZoom = 'Zoom';
export var ToastTransitionFlip = 'Flip';
export var ToastTransitionBounce = 'Bounce';